module.exports = "data:image/webp;base64,UklGRv4AAABXRUJQVlA4IPIAAAAwBgCdASoZABkAPpE6lEelo6IhMBgMALASCWMAnTKDJ7LAMMAI3WjKPw2Z8EelA/cJ+4GdZtqKfRDwAPnr2fLCegUi0CzyuZMY52pBGKC3harf0pXuxLoeBe3vPDZTUp0yPdmW4am+AwdFDNXB95NbENnQgTDFr1t1q+djHS0yxesjTCMPBfX6YgU1Z5MAgWqaUB+KX/DToMdTePm7lSiUXn2n+cFWq/SVgaRSLuq+O60ElSmTd/qvU3lVMQWISCuJPtcYOaZWlmLaBskDaUeaGn0QTtlEppLDM6tbRvClkafuvr4/opURE2EcC2QO+BQAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/black_brown.webp
// module id = yQKd
// module chunks = 14